import Server from "./../../../Dashboard/Server";
import { useParams } from "react-router";
import { Link } from "react-router-dom"
import ChevronDots from "./../ProgressSteps"
import Spinner from './../../../elements/Spinner'
import { useEffect, useState } from "react";
import Card from "../../../elements/Card";
import { GameLocation, GetClientGamelocationsByGame } from "../../../../api/api.gen";
import { capitalizeWords, getCurrencyTranslated } from "../../../../utils/util";
import { Button } from "@mantine/core";
import useGlobalState from "@/state";

const GameSelection = () => {
    let { gamename, cat } = useParams();
    const [Locations, setLocations] = useState<GameLocation[]>();
    const [PingValues, setPingValues] = useState<any>({})
    const [loading, setLoading] = useState(false);
    const [isSortByPing, setisSortByPing] = useState(false)

    const selectedCurrency = useGlobalState(state => state.selectedCurrency)

    const onRender = (gamename : string) => {
        document.title = capitalizeWords(gamename) + " Hosting - SNHCloud.com"
        setLoading(true)
        GetClientGamelocationsByGame(gamename)
        .then(response => {
            setLocations(response)
        })
        .then(() => setLoading(false));
    }
    
    useEffect(() => {
        const oldTile = document.title
        onRender(gamename);
        return () => {
            document.title = oldTile
        }
    }, [gamename, cat]);

    const getSortedLocations = (): GameLocation[] => {
        var toRet = isSortByPing ? Locations
        ?.slice()
        .sort((a, b) => (PingValues[a.Location] || 1000) - (PingValues[b.Location] || 1000))
        : Locations
        return toRet ? toRet : []
    }

    return(
        <>
        {loading &&
            <Spinner />
        }
        <h1 className="text-center mt-2">{capitalizeWords(gamename)} {capitalizeWords(cat.replaceAll("-", " "))} Hosting</h1>
        <div className="flex items-center justify-center">
            <Button onClick={() => setisSortByPing(true)}>Sort by low ping</Button>
        </div>
        <div className="grid center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:px-20 my-8">
            {getSortedLocations().map(e => (
                <Link key={e.Location} to={`/hosting/${cat}/${gamename}/${e.Location}`}>
                <Card 
                    name={e.Location} 
                    banner={e.Location} 
                    extra={!e.Units ? -1 : -2} 
                    ping={e.Ping} 
                    subtitle={`Starting from ${getCurrencyTranslated(e.StartingFrom, selectedCurrency)}`}
                    setDataUp={(k, v) => setPingValues((ov: any) => ({...ov, [k]: v}))}
                />
                </Link>    
            ))}
        </div>
        <div className="text-2xl text-center">
            Contact us via a Discord Ticket in case the location your looking for is not above 
        </div>
        </>
    )
}

export default GameSelection;